import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import VerticalTabsCustom from '../verticalTabsCustom/verticalTabsCustom';
import TextLabel from '../textLabel/textLabel';
import InfoIcon from '../infoIcon/infoIcon';

var CorvidSiteStructure = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CorvidSiteStructure, _React$PureComponent);

  var _super = _createSuper(CorvidSiteStructure);

  function CorvidSiteStructure() {
    _classCallCheck(this, CorvidSiteStructure);

    return _super.apply(this, arguments);
  }

  _createClass(CorvidSiteStructure, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getClassName = _this$props.getClassName,
          dataHook = _this$props.dataHook,
          value = _this$props.value,
          onChange = _this$props.onChange,
          collapsed = _this$props.collapsed,
          topTabs = _this$props.topTabs,
          bottomTabs = _this$props.bottomTabs,
          headerText = _this$props.headerText,
          infoText = _this$props.infoText,
          infoLinkText = _this$props.infoLinkText,
          onLinkClick = _this$props.onLinkClick,
          onBarClick = _this$props.onBarClick,
          children = _this$props.children;
      var showInfoIcon = Boolean(infoText || infoLinkText);
      var currentValue = collapsed ? null : value;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: getClassName('corvid-site-structure')
      }, /*#__PURE__*/React.createElement("div", {
        className: "vertical-tabs",
        "data-hook": "vertical-tabs"
      }, /*#__PURE__*/React.createElement(VerticalTabsCustom, {
        closed: false,
        value: currentValue,
        onChange: onChange,
        options: topTabs
      }), /*#__PURE__*/React.createElement("div", {
        className: "empty-space",
        "data-hook": "empty-space",
        onClick: onBarClick
      }), /*#__PURE__*/React.createElement("div", {
        className: "bottom-tabs"
      }, /*#__PURE__*/React.createElement(VerticalTabsCustom, {
        closed: false,
        value: currentValue,
        onChange: onChange,
        options: bottomTabs
      }))), !collapsed && /*#__PURE__*/React.createElement("div", {
        className: "tab-container",
        "data-hook": "tab-container"
      }, headerText && /*#__PURE__*/React.createElement("div", {
        className: "tab-header",
        "data-hook": "tab-header"
      }, /*#__PURE__*/React.createElement(TextLabel, {
        className: "tab-header-label",
        dataHook: "tab-header-label",
        value: headerText,
        type: "T21"
      }), showInfoIcon && /*#__PURE__*/React.createElement(InfoIcon, {
        dataHook: "tab-header-info-icon",
        text: infoText,
        linkText: infoLinkText,
        onLinkClick: onLinkClick
      })), /*#__PURE__*/React.createElement("div", {
        className: "tab-content",
        "data-hook": "tab-content"
      }, children)));
    }
  }]);

  return CorvidSiteStructure;
}(React.PureComponent);

CorvidSiteStructure.displayName = 'CorvidSiteStructure';
var tabPropType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  symbol: PropTypes.node.isRequired
});
CorvidSiteStructure.propTypes = {
  dataHook: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  topTabs: PropTypes.arrayOf(tabPropType),
  bottomTabs: PropTypes.arrayOf(tabPropType),
  collapsed: PropTypes.bool,
  headerText: PropTypes.string.isRequired,
  infoText: PropTypes.string,
  infoLinkText: PropTypes.string,
  onLinkClick: PropTypes.func,
  onBarClick: PropTypes.func
};
CorvidSiteStructure.defaultProps = {
  topTabs: [],
  bottomTabs: [],
  collapsed: false,
  onBarClick: _.noop
};
export default compose(CorvidSiteStructure);